export default __webpack_public_path__ + "static/media/slide_one.bdab19df.jpg";